import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import './HRDashboardStyled.scss';
import DownloadButtonBlack24 from './images/DownloadButtonBlack24.png';
import ShowButtonBlack from './images/ShowButtonBlack.png';
import { SeeMore, OnlyInformation, AntiquityAverage, EmployeeDistribution, EmployeeByNationality } from './components';
import AgeDistribution from './components/AgeDistribution';
import BlankCard from './components/BlankCard';
import { sendAlert } from '../../actions/utils';
import {
  exportDisabilityEmployeesRequest,
  exportEmployeesRequest,
  exportFixedTermContractsRequest,
  exportUndefinedTermContractsRequest
} from '../../requests/employees';
import { downloadFile } from '../../services/utils';
import { DefaultModal } from '../Utils/Modal';
import InfoCard from './components/InfoCard';
import ChileansNoChileansEmployees from './components/ChileansNoChileansEmployees';
import GroupByAgeDistribution from './components/GroupByAgeDistribution';
import CivilStateGraph from './components/CivilStateGraph';
import GroupByAntiquityGraph from './components/GroupByAntiquityGraph';
import MonthlyContractSummary from './components/MonthlyContractSummary';
import DinamicGraph from './components/DinamicGraph';
import Icon from '../Icons';
import TodayAttendanceAbsences from './components/TodayAttendanceAbsences';

const HRDashboardStyled = ({
  title = '',
  label = '',
  subtitle = '',
  subtitle2 = '',
  titleSize = '20px',
  subtitle2FontSize = '14px',
  AnyList = '',
  TopHeaderColor = '',
  GeneralColor = '',
  TypeCard = '',
  CardName = '',
  onClick = () => {},
  onRequest = false,
  nationalities = [],
  labelFontSize = '13px',
  labelColor = '',
  Downloadable = false,
  ViewMore = false,
  DownIcon = false,
  fontSizeSubtitle = '12px',
  maxHeight = 250,
  topHeight = 35,
  heightDiv = null,
  setMaxHeight = () => {},
  filter = 'jobManagement',
  setFilter = () => {},
  handleMoreInfoButton = () => {},
  customTitleStyle = {},
  customSubtitleStyle = {},
  customSubtitle2Style = {},
  customLabelStyle = {}
}) => {
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [modalBody, setModalBody] = useState('');
  const [modalAction, setModalAction] = useState(() => null);
  const [modalTitle, setModalTitle] = useState('');
  const [downloadParams, setDownloadParams] = useState({});

  const handleModalClose = () => {
    setModalShow(false);
  };

  const handleFailureRequest = error => {
    const { response } = error;
    if (!response) {
      dispatch(sendAlert({ kind: 'error', message: error.message }));
    } else {
      let errorMessage = response.statusText;
      if (response.data && response.data.message) {
        errorMessage = response.data.message;
      }
      dispatch(sendAlert({ kind: 'error', message: errorMessage }));
    }
    setDisabled(false);
    setModalShow(false);
  };

  const handleExportRequest = parameters => {
    setDisabled(true);
    switch (CardName) {
      case 'Disability':
        exportDisabilityEmployeesRequest({
          dispatch,
          params: {
            display_start: 0,
            display_length: 15,
            sort_direction: 'asc',
            sort_column: 'name',
            active: true,
            ...parameters
          },
          successCallback: response => {
            downloadFile(response);
            setDisabled(false);
            setModalShow(false);
          },
          failureCallback: handleFailureRequest
        });
        return;
      case 'UndefinedContracts':
        exportUndefinedTermContractsRequest({
          dispatch,
          params: {
            display_start: 0,
            display_length: 15,
            sort_direction: 'asc',
            sort_column: 'name',
            active: true,
            ...parameters
          },
          successCallback: response => {
            downloadFile(response);
            setDisabled(false);
            setModalShow(false);
          },
          failureCallback: handleFailureRequest
        });
        return;
      case 'FixedTermContracts':
        exportFixedTermContractsRequest({
          dispatch,
          params: {
            display_start: 0,
            display_length: 15,
            sort_direction: 'asc',
            sort_column: 'name',
            active: true,
            ...parameters
          },
          successCallback: response => {
            downloadFile(response);
            setDisabled(false);
            setModalShow(false);
          },
          failureCallback: handleFailureRequest
        });
        return;
      default:
        exportEmployeesRequest({
          dispatch,
          params: {
            display_start: 0,
            display_length: 15,
            sort_direction: 'asc',
            sort_column: 'name',
            active: true,
            ...parameters
          },
          successCallback: response => {
            downloadFile(response);
            setDisabled(false);
            setModalShow(false);
          },
          failureCallback: handleFailureRequest
        });
    }
  };

  const handleParams = () => {
    switch (CardName) {
      case 'UndefinedContracts':
        setDownloadParams({
          filter_contract_type: 'undefined_term',
          active_staffing: true,
          dotation_today: true
        });
        break;
      case 'FixedTermContracts':
        setDownloadParams({
          filter_not_undefined_term: true,
          active_staffing: true,
          dotation_today: true
        });
        break;
      case 'Disability':
        setDownloadParams({
          with_disability: true
        });
        break;
      default:
        console.log('');
        break;
    }
  };

  const handleClick = () => {
    handleParams();
    setModalTitle('Exportar empleados');
    setModalShow(true);
    setModalBody('¿Estás seguro que deseas exportar empleados?');
    setModalAction(() => handleExportRequest);
  };

  function RenderDashboard() {
    switch (TypeCard) {
      case 'Colaborators':
        return <InfoCard title={title} subtitle={subtitle} TopHeaderColor={TopHeaderColor} onRequest={onRequest} />;

      case 'SeeMore':
        return (
          <SeeMore
            title={title}
            subtitle={subtitle}
            subtitle2={subtitle2}
            subtitle2FontSize={subtitle2FontSize}
            TopHeaderColor={TopHeaderColor}
            GeneralColor={GeneralColor}
            onClick={onClick}
            onRequest={onRequest}
          />
        );

      case 'OnlyInformation':
        return (
          <OnlyInformation
            title={title}
            subtitle={subtitle}
            subtitle2={subtitle2}
            TopHeaderColor={TopHeaderColor}
            onRequest={onRequest}
            GeneralColor={GeneralColor}
            fontSizeSubtitle={fontSizeSubtitle}
            labelColor={labelColor}
            customTitleStyle={customTitleStyle}
            customSubtitleStyle={customSubtitleStyle}
            customSubtitle2Style={customSubtitle2Style}
            titleSize={titleSize}
          />
        );

      case 'AntiquityAverage':
        return (
          <AntiquityAverage title={title} subtitle={subtitle} TopHeaderColor={TopHeaderColor} onRequest={onRequest} />
        );

      case 'EmployeeDistribution':
        return (
          <EmployeeDistribution
            title={title}
            subtitle={subtitle}
            AnyList={AnyList}
            onRequest={onRequest}
            maxHeight={maxHeight}
            setMaxHeight={setMaxHeight}
          />
        );

      case 'AgeDistribution':
        return <AgeDistribution title={title} subtitle={subtitle} onRequest={onRequest} />;

      case 'EmployeeByNationality':
        return <EmployeeByNationality nationalities={nationalities} subtitle={subtitle} onRequest={onRequest} />;

      case 'ChileansNoChileansEmployees':
        return <ChileansNoChileansEmployees title={title} subtitle={subtitle} onRequest={onRequest} />;

      case 'GroupByAgeDistribution':
        return <GroupByAgeDistribution title={title} />;

      case 'GroupByCivilState':
        return <CivilStateGraph title={title} />;

      case 'GroupByAntiquityGraph':
        return <GroupByAntiquityGraph title={title} />;

      case 'MonthlyContractSummary':
        return <MonthlyContractSummary title={title} />;

      case 'DinamicGraph':
        return (
          <DinamicGraph
            title={title}
            maxHeight={maxHeight}
            setMaxHeight={setMaxHeight}
            filter={filter}
            setFilter={setFilter}
          />
        );

      case 'TodayAttendanceAbsences':
        return <TodayAttendanceAbsences title={title} subtitle={subtitle} onRequest={onRequest} />;

      default:
        return <></>;
    }
  }
  return (
    <>
      {!onRequest && (
        <div
          id="HRDashboard"
          style={{
            backgroundColor: '#fff',
            border: '1px solid #E0E0E0',
            borderRadius: '8px',
            height: heightDiv || '100%'
          }}
        >
          <div
            style={{
              textAlign: 'center',
              backgroundColor: TopHeaderColor,
              borderTopRightRadius: 8,
              borderTopLeftRadius: 8,
              height: topHeight
            }}
          >
            <Row>
              <Col
                className="mt-2"
                md={!Downloadable && !ViewMore ? 12 : 8}
                xl={!Downloadable && !ViewMore ? 12 : 8}
                xs={!Downloadable && !ViewMore ? 12 : 8}
              >
                <p
                  style={{
                    fontSize: labelFontSize,
                    fontWeight: 'bold',
                    color: labelColor || 'black',
                    textAlign: 'left',
                    marginLeft: '10px',
                    ...customLabelStyle
                  }}
                >
                  {label}
                </p>
              </Col>
              {Downloadable && (
                <Col md={4} xl={4} xs={4} style={{ paddingRight: '30px' }}>
                  <div className="DownloadButton">
                    <button type="button" onClick={handleClick} style={{ backgroundColor: TopHeaderColor }}>
                      <img src={DownloadButtonBlack24} alt="DownloadButtonImage.png" />
                    </button>
                  </div>
                </Col>
              )}
              {ViewMore && (
                <Col md={4} xl={4} xs={4} style={{ paddingRight: '30px' }}>
                  <div className="DownloadButton">
                    <button type="button" onClick={onClick} style={{ backgroundColor: TopHeaderColor }}>
                      <img src={ShowButtonBlack} alt="DownloadButtonImage.png" />
                    </button>
                  </div>
                </Col>
              )}
            </Row>
          </div>

          <div style={{ paddingRight: 15, paddingLeft: 15 }}>
            <RenderDashboard />
          </div>

          {DownIcon && (
            <div style={{ textAlign: 'right', paddingRight: 15 }}>
              <button
                type="button"
                onClick={handleMoreInfoButton}
                style={{
                  border: '1px solid #65b68f',
                  backgroundColor: '#65b68f',
                  position: 'absolute',
                  right: 25,
                  bottom: 25
                }}
                className="mb-2"
              >
                <Icon icon="search" height="25px" width="16px" color="white" />
              </button>
            </div>
          )}
        </div>
      )}
      {onRequest && <BlankCard isChart={TypeCard === 'EmployeeDistribution' || TypeCard === 'AgeDistribution'} />}
      <DefaultModal
        title={modalTitle}
        body={modalBody}
        show={modalShow}
        handleClose={handleModalClose}
        handleConfirm={() => modalAction(downloadParams)}
        titleBtnClose="Cancelar"
        titleBtnSave="Confirmar"
        disabled={onRequest || disabled}
      />
    </>
  );
};

export default HRDashboardStyled;
